module.exports = __webpack_public_path__ + "img/Switzerland.f3579276.svg";